<section class="erp" id="erp">
  <div class="erp-content">
    <span class="erp-tag">All-in-one dashboard</span>
    <h2>Run Your Whole Business with Orderyaa ERP</h2>
    <p>
      Manage inventory, sales, staff, and reports from a single POS and ERP dashboard —
      built to keep every store and every order in sync.
    </p>

    <ul class="erp-perks">
      <li>Real-time inventory &amp; sales tracking</li>
      <li>Multi-store management</li>
      <li>Staff and payroll in one place</li>
    </ul>

    <a
      class="erp-cta"
      [href]="erpAppUrl"
      target="_blank"
      rel="noopener"
    >
      Open Orderyaa ERP
    </a>
  </div>

  <div class="erp-visual">
    <div class="erp-circle"></div>
    <img class="erp-img" src="/images/pos-app.webp" alt="Orderyaa ERP & POS" />
  </div>
</section>
